import api from '../api/axios';

const curralLayoutService = {
  async getLayout(organizadorId) {
    const { data } = await api.get(`/organizadores/${organizadorId}/curral-layout`);
    return data; // { currais: [...], colunas: 12 }
  },

  async saveLayout(organizadorId, { currais, colunas, usar_curral_como_numero_lote }) {
    const { data } = await api.put(`/organizadores/${organizadorId}/curral-layout`, { currais, colunas, usar_curral_como_numero_lote });
    return data;
  },
};

export default curralLayoutService;
